function PowerBISchools() {
  return (
    <div style={{ width: "90%", height: "90%" }}>
      <iframe
        title="Schools"
        style={{ width: "100%", height: "100%" }}
        src="https://app.powerbi.com/reportEmbed?reportId=3bb814c6-af20-4c9a-b729-58574711595a&autoAuth=true&ctid=5fb461ed-7397-4bdd-9dc6-5db63180bbb1"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default PowerBISchools;
